'use strict';

var exp = require('./experiment');

/**
 * @param {Object} context
 * @returns {Object} experiment module with bound context
 */
function build(context) {
  return {
    getRunningExperiments: function getRunningExperiments(override) {
      return exp.getRunningExperiments(override || context);
    },
    isOpen: function isOpen(name, override) {
      return exp.isOpen(name, override || context);
    },
    getValue: function getValue(name, override) {
      return exp.getValue(name, override || context);
    },
    isMultiValueExperimentOpen: function isMultiValueExperimentOpen(name, override) {
      return exp.isMultiValueExperimentOpen(name, override || context);
    }
  };
}

module.exports = {
  build: build
};
//# sourceMappingURL=experimentFactory.js.map